    'use client';

    import React, {useContext} from 'react';
    import { Htag } from './ui/htag';
    import { P } from './ui/P';
    import { BadgePercent, Clock3, HandCoins, Sparkles } from "lucide-react";
    import FormOrder from "@/components/form-order";
    import {Button} from "@/components/ui/button";
    import {PopupContext} from "@/context/PopupContext";
    import {CardServiceProps} from "@/data/sale-data";

    interface Page {
        title: string;
        description: string;
        after?: string[];
        preTitle?: string;
    }

    export default function Start({ title, description, after, preTitle }: Page) {
        const { openPopup } = useContext(PopupContext);
        const handleClick = () => {

            openPopup('about');
        };
        const pre = () =>
            preTitle ? (
                <P size="s" className="text-gray-300 uppercase tracking-wide">
                    Центр недвижимости
                </P>
            ) : null;

        return (
            <div className="max-w-custom mx-auto py-3 lg:mt-3  flex flex-col-reverse lg:flex-row justify-between">


                            <div className="flex flex-col gap-5 my-auto mt-8 ml-6 lg:ml-12 max-w-[700px]">
                                <Htag tag="h1" className="max-w-[700px] leading-tight mb-3">
                                    {title}
                                </Htag>
                                <ul className="space-y-3 text-sm sm:text-base font-medium text-gray-500">
                                    <li className="flex items-start gap-3">
                                        <Clock3
                                            size={20}
                                            className="text-gray-300 group-hover:text-primary transition-colors flex-shrink-0"
                                        />
                                        <span>
                                            <span className=" ">{after?.[0]}</span>{' '}
                                            <span className="text-orange-400">{after?.[1]}</span>
                                        </span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <BadgePercent
                                            size={20}
                                            className="text-gray-300 group-hover:text-primary transition-colors flex-shrink-0"
                                        />
                                        <span>
                                            {after?.[2]}{' '}
                                            <span className="text-orange-400 font-semibold">{after?.[3]}</span>{' '}
                                            {after?.[4]}
                                        </span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <Sparkles
                                            size={20}
                                            className="text-gray-300 group-hover:text-primary transition-colors flex-shrink-0"
                                        />
                                        <span>{after?.[5]}</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <HandCoins
                                            size={20}
                                            className="text-gray-300 group-hover:text-primary transition-colors flex-shrink-0"
                                        />
                                        <span>{after?.[6]}</span>
                                    </li>
                                </ul>
                                <Button className='mt-6 text-sm' onClick={handleClick} >ПОДРОБНЕЕ</Button>
                            </div>
                <img className={'w-[350px] lg:w-[600px]'}
                     src={'/fon.png'
                }/>
            </div>
        );
    }
